export default {
  'processes.title': 'Meus Processos',
  'processes.newProcess': 'Novo Processo',
  'processes.cloning': 'Clonando',
  'processes.editing': 'Editando',
  'processes.creating': 'Criando',
  'processes.process': 'Processo',
  'processes.name': 'Nome',
  'processes.userGroups': 'Grupos de usuários',
  'processes.icon': 'Ícone',
  'processes.color': 'Cor',
  'processes.embedLink': 'Link de incorporação',
  'processes.kanban': 'Kanban',
  'processes.list': 'Lista',
  'processes.dashboard': 'Dashboard',
  'processes.table.code': 'Código',
  'processes.table.responsible': 'Responsável',
  'processes.table.destination': 'Destino',
  'processes.table.scheduling': 'Agendamento',
  'processes.table.completion': 'Conclusão',
  'processes.table.status': 'Status',
  'processes.table.priority': 'Prioridade',
  'processes.table.openedAt': 'Aberto em',
  'processes.actionPlans.showMore': 'Mostrar outros {count} planos de ação',
  'processes.search.normal': 'Busca normal',
  'processes.search.byReply': 'Busca por resposta',
  'processes.search.byAdditionalField': 'Busca por campo adicional',
  'processes.search.byDestination': 'Busca por destino',
  'processes.error.createActivity': 'Erro inesperado ao criar atividade',
  'processes.dates.title': 'Datas',
  'processes.dates.opening': 'Abertura',
  'processes.dates.scheduling': 'Agendamento',
  'processes.dates.completion': 'Conclusão',
  'processes.dates.multiple': '{count} datas',
  'processes.validation.required': 'Campo obrigatório',
  'processes.validation.invalidUrl': 'URL inválida',
  'processes.remove.confirm': 'Certeza que deseja remover?',
  'processes.remove.success': 'Processo removido com sucesso!',
  'processes.remove.error': 'Ocorreu um erro ao remover!',
  'processes.kanban.addColumn': 'Adicionar Coluna',
  'processes.welcome': 'Boas-vindas, {name}!',
  'processes.welcomeMessage': 'Veja o que temos preparado para você hoje.'
}
